module.exports = __webpack_public_path__ + "img/keyboard-arrow-top.147272b6.svg";